import { render } from "./PersonalInformation.vue?vue&type=template&id=115f3bc6&ts=true"
import script from "./PersonalInformation.vue?vue&type=script&lang=ts"
export * from "./PersonalInformation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__